import React, { useEffect } from 'react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  projectName: string
}

export const EmptyState = ({ projectName }: EmptyStateProps) => {
  // Generate Matrix-style columns
  const columns = Array.from({ length: 30 }, (_, i) => i)
  
  useEffect(() => {
    // Add keyframes to document if not already present
    const styleId = 'matrix-animation-style'
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style')
      style.id = styleId
      style.textContent = `
        @keyframes matrix-fall {
          0% {
            transform: translateY(-100%);
          }
          100% {
            transform: translateY(100%);
          }
        }
      `
      document.head.appendChild(style)
    }
    
    return () => {
      // Cleanup if component unmounts
      const style = document.getElementById(styleId)
      if (style) {
        style.remove()
      }
    }
  }, [])
  
  return (
    <div className="flex flex-col items-center justify-center py-20 px-8 border rounded-2xl bg-white dark:bg-gray-800 shadow-sm h-full w-full relative overflow-hidden">
      {/* Matrix-style waterfall animation */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 flex justify-between">
          {columns.map((col) => (
            <div
              key={col}
              className="relative h-full flex flex-col"
              style={{
                animation: `matrix-fall ${15 + Math.random() * 10}s linear infinite`,
                animationDelay: `${Math.random() * 10}s`,
              }}
            >
              {/* Random characters for Matrix effect */}
              {Array.from({ length: 20 }, (_, i) => (
                <span
                  key={i}
                  className="text-[#FF4A8E]/25 font-mono text-sm"
                  style={{
                    opacity: Math.random() * 0.5 + 0.1,
                  }}
                >
                  {String.fromCharCode(65 + Math.floor(Math.random() * 26))}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Transcripts icon */}
      <div className="w-20 h-20 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-8 relative z-10">
        <svg className="w-10 h-10 text-[#FF4A8E]" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_transcripts_icon)">
            <path
              d="M28.3334 33.3346H10C8.67392 33.3346 7.40215 32.8078 6.46447 31.8701C5.52678 30.9324 5 29.6607 5 28.3346C5 27.0086 5.52678 25.7369 6.46447 24.7992C7.40215 23.8615 8.67392 23.3346 10 23.3346H28.3334C27.0073 23.3346 25.7355 23.8615 24.7978 24.7992C23.8601 25.7369 23.3334 27.0086 23.3334 28.3346C23.3334 29.6607 23.8601 30.9324 24.7978 31.8701C25.7355 32.8078 27.0073 33.3346 28.3334 33.3346ZM28.3334 33.3346H30C31.3261 33.3346 32.5978 32.8078 33.5355 31.8701C34.4732 30.9324 35 29.6607 35 28.3346V10.0013C35 9.11724 34.6488 8.2694 34.0237 7.64428C33.3986 7.01915 32.5507 6.66797 31.6667 6.66797H15C14.1159 6.66797 13.2681 7.01915 12.643 7.64428C12.0179 8.2694 11.6667 9.11724 11.6667 10.0013V23.3346"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_transcripts_icon">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <h3 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4 relative z-10">
        No transcripts available yet
      </h3>
      <p className="text-gray-500 dark:text-gray-400 text-center text-lg mb-8 relative z-10 max-w-3xl mx-auto">
        Add meetings to {projectName} and let Usermuse transcribe them automatically. The transcripts will help you analyze conversations and extract valuable insights.
      </p>

      {/* <div className="flex flex-col gap-4 relative z-10">
        <Button
          onClick={() => window.location.href = '/dashboard/meetings'}
          className="bg-[#FF4A8E] hover:bg-[#ff2c7d] text-white px-8 py-3 text-lg"
        >
          Go to Meetings
        </Button>
      </div> */}
    </div>
  )
} 